import { StatusWrapper } from '@/components/StatusWrapper/StatusWrapper';
import { SecureLinkType } from '@/types/myVaultTypes';
import { SECURE_LINK_STATUS_MAP } from '../const/const';

export const SecureLinkStatus = ({ link }: { link: SecureLinkType }) => {
  return <StatusWrapper variant={SECURE_LINK_STATUS_MAP[link.status]?.variant}>{link.status_label}</StatusWrapper>;
};
